// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import type { Model } from "../types.ts";

export const GITHUB_COPILOT_MODELS = {
	"claude-fable-5": {
		id: "claude-fable-5",
		name: "Claude Fable 5",
		api: "openai-completions",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
		reasoning: true,
		thinkingLevelMap: {"off":null,"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 10,
			output: 50,
			cacheRead: 1,
			cacheWrite: 12.5,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"openai-completions">,
	"claude-haiku-4.5": {
		id: "claude-haiku-4.5",
		name: "Claude Haiku 4.5 (latest)",
		api: "anthropic-messages",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		compat: {"supportsEagerToolInputStreaming":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1,
			output: 5,
			cacheRead: 0.1,
			cacheWrite: 1.25,
		},
		contextWindow: 200000,
		maxTokens: 64000,
	} satisfies Model<"anthropic-messages">,
	"claude-opus-4.5": {
		id: "claude-opus-4.5",
		name: "Claude Opus 4.5 (latest)",
		api: "anthropic-messages",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 25,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 200000,
		maxTokens: 32000,
	} satisfies Model<"anthropic-messages">,
	"claude-opus-4.6": {
		id: "claude-opus-4.6",
		name: "Claude Opus 4.6",
		api: "anthropic-messages",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		compat: {"forceAdaptiveThinking":true},
		reasoning: true,
		thinkingLevelMap: {"max":"max"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 25,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 1000000,
		maxTokens: 32000,
	} satisfies Model<"anthropic-messages">,
	"claude-opus-4.7": {
		id: "claude-opus-4.7",
		name: "Claude Opus 4.7",
		api: "anthropic-messages",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		compat: {"forceAdaptiveThinking":true,"supportsTemperature":false},
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max","minimal":"low"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 25,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 1000000,
		maxTokens: 32000,
	} satisfies Model<"anthropic-messages">,
	"claude-opus-4.8": {
		id: "claude-opus-4.8",
		name: "Claude Opus 4.8",
		api: "anthropic-messages",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		compat: {"forceAdaptiveThinking":true,"supportsTemperature":false},
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max","minimal":"low"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 25,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 1000000,
		maxTokens: 64000,
	} satisfies Model<"anthropic-messages">,
	"claude-sonnet-4": {
		id: "claude-sonnet-4",
		name: "Claude Sonnet 4 (latest)",
		api: "anthropic-messages",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		compat: {"supportsEagerToolInputStreaming":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 3,
			output: 15,
			cacheRead: 0.3,
			cacheWrite: 3.75,
		},
		contextWindow: 216000,
		maxTokens: 16000,
	} satisfies Model<"anthropic-messages">,
	"claude-sonnet-4.5": {
		id: "claude-sonnet-4.5",
		name: "Claude Sonnet 4.5 (latest)",
		api: "anthropic-messages",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		compat: {"supportsEagerToolInputStreaming":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 3,
			output: 15,
			cacheRead: 0.3,
			cacheWrite: 3.75,
		},
		contextWindow: 200000,
		maxTokens: 32000,
	} satisfies Model<"anthropic-messages">,
	"claude-sonnet-4.6": {
		id: "claude-sonnet-4.6",
		name: "Claude Sonnet 4.6",
		api: "anthropic-messages",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		compat: {"forceAdaptiveThinking":true},
		reasoning: true,
		thinkingLevelMap: {"max":"max","minimal":"low"},
		input: ["text", "image"],
		cost: {
			input: 3,
			output: 15,
			cacheRead: 0.3,
			cacheWrite: 3.75,
		},
		contextWindow: 1000000,
		maxTokens: 32000,
	} satisfies Model<"anthropic-messages">,
	"claude-sonnet-5": {
		id: "claude-sonnet-5",
		name: "Claude Sonnet 5",
		api: "anthropic-messages",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		compat: {"forceAdaptiveThinking":true},
		reasoning: true,
		thinkingLevelMap: {"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 10,
			cacheRead: 0.2,
			cacheWrite: 2.5,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"anthropic-messages">,
	"gemini-2.5-pro": {
		id: "gemini-2.5-pro",
		name: "Gemini 2.5 Pro",
		api: "openai-completions",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 10,
			cacheRead: 0.125,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 64000,
	} satisfies Model<"openai-completions">,
	"gemini-3-flash-preview": {
		id: "gemini-3-flash-preview",
		name: "Gemini 3 Flash Preview",
		api: "openai-completions",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.5,
			output: 3,
			cacheRead: 0.05,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 64000,
	} satisfies Model<"openai-completions">,
	"gemini-3.1-pro-preview": {
		id: "gemini-3.1-pro-preview",
		name: "Gemini 3.1 Pro Preview",
		api: "openai-completions",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 12,
			cacheRead: 0.2,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 64000,
	} satisfies Model<"openai-completions">,
	"gemini-3.5-flash": {
		id: "gemini-3.5-flash",
		name: "Gemini 3.5 Flash",
		api: "openai-completions",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.5,
			output: 9,
			cacheRead: 0.15,
			cacheWrite: 0,
		},
		contextWindow: 200000,
		maxTokens: 64000,
	} satisfies Model<"openai-completions">,
	"gpt-4.1": {
		id: "gpt-4.1",
		name: "GPT-4.1",
		api: "openai-completions",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 8,
			cacheRead: 0.5,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 16384,
	} satisfies Model<"openai-completions">,
	"gpt-5-mini": {
		id: "gpt-5-mini",
		name: "GPT-5 Mini",
		api: "openai-responses",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":"low"},
		input: ["text", "image"],
		cost: {
			input: 0.25,
			output: 2,
			cacheRead: 0.025,
			cacheWrite: 0,
		},
		contextWindow: 264000,
		maxTokens: 64000,
	} satisfies Model<"openai-responses">,
	"gpt-5.2": {
		id: "gpt-5.2",
		name: "GPT-5.2",
		api: "openai-responses",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":"low","xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 1.75,
			output: 14,
			cacheRead: 0.175,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"openai-responses">,
	"gpt-5.2-codex": {
		id: "gpt-5.2-codex",
		name: "GPT-5.2 Codex",
		api: "openai-responses",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":"low","xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 1.75,
			output: 14,
			cacheRead: 0.175,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"openai-responses">,
	"gpt-5.3-codex": {
		id: "gpt-5.3-codex",
		name: "GPT-5.3 Codex",
		api: "openai-responses",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":"low","xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 1.75,
			output: 14,
			cacheRead: 0.175,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"openai-responses">,
	"gpt-5.4": {
		id: "gpt-5.4",
		name: "GPT-5.4",
		api: "openai-responses",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":"low","xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 2.5,
			output: 15,
			cacheRead: 0.25,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"openai-responses">,
	"gpt-5.4-mini": {
		id: "gpt-5.4-mini",
		name: "GPT-5.4 mini",
		api: "openai-responses",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":"low","xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 0.75,
			output: 4.5,
			cacheRead: 0.075,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"openai-responses">,
	"gpt-5.4-nano": {
		id: "gpt-5.4-nano",
		name: "GPT-5.4 nano",
		api: "openai-responses",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":"low","xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 0.2,
			output: 1.25,
			cacheRead: 0.02,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"openai-responses">,
	"gpt-5.5": {
		id: "gpt-5.5",
		name: "GPT-5.5",
		api: "openai-responses",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":"low","xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 30,
			cacheRead: 0.5,
			cacheWrite: 0,
		},
		contextWindow: 1000000,
		maxTokens: 128000,
	} satisfies Model<"openai-responses">,
	"gpt-5.6-luna": {
		id: "gpt-5.6-luna",
		name: "GPT-5.6 Luna",
		api: "openai-responses",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":"low","xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 1,
			output: 6,
			cacheRead: 0.1,
			cacheWrite: 0,
		},
		contextWindow: 1050000,
		maxTokens: 128000,
	} satisfies Model<"openai-responses">,
	"gpt-5.6-sol": {
		id: "gpt-5.6-sol",
		name: "GPT-5.6 Sol",
		api: "openai-responses",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":"low","xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 30,
			cacheRead: 0.5,
			cacheWrite: 0,
		},
		contextWindow: 1050000,
		maxTokens: 128000,
	} satisfies Model<"openai-responses">,
	"gpt-5.6-terra": {
		id: "gpt-5.6-terra",
		name: "GPT-5.6 Terra",
		api: "openai-responses",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		reasoning: true,
		thinkingLevelMap: {"off":null,"minimal":"low","xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 2.5,
			output: 15,
			cacheRead: 0.25,
			cacheWrite: 0,
		},
		contextWindow: 1050000,
		maxTokens: 128000,
	} satisfies Model<"openai-responses">,
	"kimi-k2.7-code": {
		id: "kimi-k2.7-code",
		name: "Kimi K2.7 Code",
		api: "openai-completions",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		compat: {"supportsStore":false,"supportsDeveloperRole":false,"supportsReasoningEffort":false},
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 0.95,
			output: 4,
			cacheRead: 0.19,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 32000,
	} satisfies Model<"openai-completions">,
	"mai-code-1-flash-picker": {
		id: "mai-code-1-flash-picker",
		name: "MAI-Code-1-Flash",
		api: "openai-responses",
		provider: "github-copilot",
		baseUrl: "https://api.individual.githubcopilot.com",
		headers: {"User-Agent":"GitHubCopilotChat/0.35.0","Editor-Version":"vscode/1.107.0","Editor-Plugin-Version":"copilot-chat/0.35.0","Copilot-Integration-Id":"vscode-chat"},
		reasoning: true,
		input: ["text"],
		cost: {
			input: 0.75,
			output: 4.5,
			cacheRead: 0.075,
			cacheWrite: 0,
		},
		contextWindow: 256000,
		maxTokens: 128000,
	} satisfies Model<"openai-responses">,
} as const;
